import React, { useEffect, useRef, useState } from 'react'
import { Button, Form } from 'react-bootstrap'

import SpinerVeye from '../../../components/spinnerVeye/spinnerVeye.js'
import { api_gateway } from '../../../conexoes/api'
import { setaDropdown } from '../../../utils/alternanciaIcones'
import utilsSms from '../../../utils/sms'

/*  COMO USAR
    Importe a modal para dentro do componente que irá fazer uso dela.
    ex: import SelectUf from '../../componentesModais/selects/selectUf'

    Crie um hook apropriado para esconder e exibir a mensagem quando necessário.
    ex: const [revelarSelectUf, setRevelarSelectUf] = useState(false)

    Após isso, posicione-a dentro do return do seu componente e passe os props para
    customizar o conteúdo da mensagem da seguinte forma. É interessante utilizar um
    <Button/> com uma função onClick, dentro de um >Form.Group/> para que o campo
    se mantenha similar aos campos de texto normais.
    ex: <Form.Group>
            <Form.Label>
                <div className="fonte-cor-1 label-campo">Uf {iconeAsterisco}</div>
            </Form.Label>
            { revelarSelectUf === false &&
                <Button name="cdUf" className="campo-texto-cor-3 campo-select" onClick={() => setRevelarSelectUf(!revelarSelectUf)}>
                    <div className="fonte-cor-1 label-campo">{dsUf}</div>
                    <img className="campo-select-icone-desativado" src={setaDropdown()} alt="drop" />
                </Button>
            }
            { revelarSelectUf === true &&
                <SelectUf
                    setRevelarSelectUf={setRevelarSelectUf} //Hook para fechar a modal
                    setCdUf={setCdUf} //Código do Uf
                    setDsUf={setDsUf} //Nome do Uf
                    dsUf={dsUf} 
                    phUf={phUf} //Placeholder para mostrar o valor original em caso de edição
                >
                </SelectUf>
            }
        </Form.Group>*/

export default function SelectTemplateSms(props) {
  // SPINNER
  const [spinAtivo, setSpinAtivo] = useState(true)
  //HOOKS MODAL
  const [lsTemplateSms, setLsTemplateSms] = useState([])
  const modal = useRef()

  const handleClickFora = (e) => {
    if (!modal.current.contains(e.target)) {
      handleCancelar()
    }
  }

  function handleTemplateSms(dsTemplate, conteudo) {
    props.setDsTemplateSms(dsTemplate)
    props.setDsMensagem(conteudo)
    handleCancelar()
  }

  function handleCancelar() {
    props.setRevelarSelectTemplateSms(false)
  }

  useEffect(() => {
    async function renderTemplatesSms() {
      const query = utilsSms.getNewQueryGet('')
      const { data } = await api_gateway.get(
        '/m1/consultar/smsTemplate' + query
      )

      if (data.dados.length > 0) {
        let objetoTemplates = data.dados.map((item, i) => {
          return (
            <li key={`MENU-${item.ds_sms_template}-${i}`}>
              <div
                className="campo-select-opcao campo-texto-cor-3"
                onClick={() =>
                  handleTemplateSms(item.ds_sms_template, item.ds_conteudo)
                }
              >
                <span className="fonte-cor-1 fonte-campo campo-select-opcao-label nao-selecionavel">
                  {item.ds_sms_template}
                </span>
              </div>
              {data.dados[i + 1] != undefined && (
                <div className="campo-select-divisor-cor-1 campo-select-divisor" />
              )}
            </li>
          )
        })
        setLsTemplateSms(objetoTemplates)
      } else {
        let objetoTemplates = () => {
          return (
            <li>
              <div disabled className="campo-select-opcao campo-select-opcao-1">
                <span className="fonte-cor-1 fonte-campo campo-select-opcao-label nao-selecionavel">
                  Nenhuma informação encontrada
                </span>
              </div>
            </li>
          )
        }
        setLsTemplateSms(objetoTemplates)
      }
    }
    renderTemplatesSms()
    setSpinAtivo(false)
    document.addEventListener('mousedown', handleClickFora)
    return () => document.removeEventListener('mousedown', handleClickFora)
  }, [])

  return (
    <Form ref={modal}>
      {spinAtivo && (
        <div className="componente-spinner-overlay">
          <div className="componente-spinner-container">
            <SpinerVeye />
          </div>
        </div>
      )}
      <Button
        name="cdTemplateSms"
        className="campo-texto-cor-3 campo-select"
        onClick={() => props.setRevelarSelectTemplateSms(false)}
      >
        <div className="fonte-cor-1 label-campo">{props.dsTemplateSms}</div>
        <img
          className="campo-select-icone-ativado"
          src={setaDropdown()}
          alt="drop"
        />
      </Button>
      <div className="campo-select-triangulo-cor-1 campo-select-triangulo" />
      <div className="campo-texto-cor-3 campo-select-corpo">
        <ul className="campo-select-lista">{lsTemplateSms}</ul>
      </div>
    </Form>
  )
}
